import { Box, Typography } from '@mui/material';

export default function BankAccountDetails({ rowData, nonEnrollment }) {
  const bankAccountDetails = [
    // {
    //   label: 'Refund Account',
    //   value: 'Indian',
    // },
    {
      label: 'Account Holder Name',
      value: nonEnrollment ? rowData?.refund_ac_holder : rowData?.refund_ac_holder,
    },
    {
      label: 'Account Number',
      value: nonEnrollment ? rowData?.refund_ac_no : rowData?.refund_ac_no,
    },
    {
      label: 'IFSC Code',
      value: nonEnrollment ? rowData?.refund_ifsc : rowData?.refund_ifsc,
    },
  ];
  return (
    <Box minWidth={400} bgcolor={'#eeeeeeff'} p={3} border={'1px solid #A3A3A3'} borderRadius={2}>
      {bankAccountDetails.map(({ label, value }) => (
        <Box key={value} display={'flex'} justifyContent={'space-between'} mb={2}>
          <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
          <Typography variant="body1">{value}</Typography>
        </Box>
      ))}
    </Box>
  );
}
